import React, {useState} from "react";
import SearchIcon from "@mui/icons-material/Search";
import { SearchContainer, SearchInputField } from "./Style";

const SearchBar = ({ handleSearchChange }) => {
  const [searchValue, setSearchValue] = useState("");

  const onSearchInputChange = (event) => {
    setSearchValue(event.target.value);
    handleSearchChange(event.target.value); // remove this line then search would be only on click.
  };

  const onSearchButtonClick = () => {
    handleSearchChange(searchValue);
  };

  return (
    <SearchContainer>
      <SearchInputField
        placeholder="Question Title/Number"
        value={searchValue}
        onChange={onSearchInputChange}
      />
      <SearchIcon
        style={{
          color: "#C6CBD9",
          fontSize: "20px",
          position: "absolute",
          right: "8px",
          cursor: "pointer",
        }}
        onClick={onSearchButtonClick}
      />
    </SearchContainer>
  );
};

export default SearchBar;
